import {
  ContentLayout,
  PillarPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
} from '@silvertours/front-features';
import { useRawFeatureTranslations } from '@silvertours/front-shared';

import { Body } from '../body';

const PillarContent = ({
  content: {
    article,
    globalRating,
    introduction,
    links,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<PillarPageContent>) => {
  const translations = useRawFeatureTranslations('article');

  return (
    <Body
      variant={{ kind: 'default' }}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          variant={{ kind: 'default' }}
        />
      }
      searchData={stage?.content?.search}
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp
            rating={globalRating.content}
            title={primaryHeadline}
          />,
        ),
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        containerModule(
          'article',
          <ContentArticle
            modules={article.segments}
            translations={translations}
          />,
        ),
        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { PillarContent };
